var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FEE4E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6192 15.2381V13.3334C27.6192 12.2829 26.7649 11.4286 25.7144 11.4286H13.3335C11.7582 11.4286 10.4763 12.7105 10.4763 14.2857V25.7143C10.4763 27.8105 12.1849 28.5714 13.3335 28.5714H27.6192C28.6696 28.5714 29.5239 27.7172 29.5239 26.6667V17.1429C29.5239 16.0924 28.6696 15.2381 27.6192 15.2381ZM25.7144 23.8095H23.8097V20H25.7144V23.8095ZM13.3335 15.2381C13.0882 15.2271 12.8567 15.122 12.6871 14.9446C12.5174 14.7672 12.4227 14.5312 12.4227 14.2857C12.4227 14.0403 12.5174 13.8043 12.6871 13.6269C12.8567 13.4495 13.0882 13.3443 13.3335 13.3334H25.7144V15.2381H13.3335Z",
    fill: "#B42318"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.57087 24.5714C8.57087 28.3585 11.6409 31.4285 15.428 31.4285C19.2151 31.4285 22.2852 28.3585 22.2852 24.5714C22.2852 20.7843 19.2151 17.7142 15.428 17.7142C11.6409 17.7142 8.57087 20.7843 8.57087 24.5714ZM16.0341 27.7489L18.6055 25.1775C18.9403 24.8427 18.9403 24.3 18.6055 23.9653C18.2708 23.6305 17.7281 23.6305 17.3934 23.9653L16.2852 25.0735L16.2852 21.9999C16.2852 21.5266 15.9014 21.1428 15.428 21.1428C14.9546 21.1428 14.5709 21.5266 14.5709 21.9999L14.5709 25.0735L13.4627 23.9653C13.1279 23.6305 12.5852 23.6305 12.2505 23.9653C11.9158 24.3 11.9158 24.8427 12.2505 25.1775L14.8219 27.7489C15.1567 28.0836 15.6994 28.0836 16.0341 27.7489Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedWallet);
export default __webpack_public_path__ + "static/media/red-wallet.a7a85a892a491033acbcc74e570980a0.svg";
export { ForwardRef as ReactComponent };